import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { getIsAdopted } from '@wix/da-shared-react/pkg/utils/adoptables';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import StatItem from '../../../../_partials/StatItem';

interface Props {
  deviation: PapiDeviation;
}

const ExclusivePriceStat: FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const isSold = getIsAdopted(deviation);
  if (isSold) {
    const soldPrice =
      deviation.adoptable?.fixedPrice?.fixedPrice ??
      deviation.adoptable?.offers?.offerPrice;
    return (
      <StatItem
        title={t('studio.products.exclusive.stats.soldPrice')}
        value={formatDollars(soldPrice)}
      />
    );
  } else if (deviation.adoptable?.offers && deviation.adoptable.fixedPrice) {
    return (
      <StatItem
        title={t('studio.products.exclusive.stats.fixedPriceOrOffer')}
        value={formatDollars(deviation.adoptable.fixedPrice.fixedPrice)}
      />
    );
  } else if (deviation.adoptable?.offers) {
    return (
      <StatItem
        title={t('studio.products.exclusive.stats.startingPrice')}
        value={formatDollars(deviation.adoptable.offers.offerPrice)}
      />
    );
  } else if (deviation.adoptable?.fixedPrice) {
    return (
      <StatItem
        title={t('studio.products.exclusive.stats.fixedPrice')}
        value={formatDollars(deviation.adoptable.fixedPrice.fixedPrice)}
      />
    );
  } else {
    return (
      <StatItem
        title={t('studio.products.exclusive.stats.startingPrice')}
        disabled
      />
    );
  }
};
ExclusivePriceStat.displayName = 'ExclusivePriceStat';

export default ExclusivePriceStat;
